module.exports = __webpack_public_path__ + "media/images/index/area/faeture_kanto-3bf3519713e1ff05113bee50ffbb297f.png";